import React from "react";

const InvoiceForm = ({ recipient, onAddRecipient, brandData }) => {
  return (
    <div className="invoice-form">
      {/* Bill To Section */}
      <div className="bill-to bg-gray-100 border border-gray-200 rounded-lg p-4">
        <h3 className="text-base font-semibold  mb-3">Bill To</h3>

        {recipient ? (
          <div className="recipient-info space-y-1 text-gray-700">
            <p className="font-medium text-sm truncate" title={recipient.name}>{recipient.name}</p>
            {recipient.company && (
              <p className="text-xs text-gray-600 truncate" title={recipient.company}>{recipient.company}</p>
            )}
            <p className="text-xs text-gray-600 truncate" title={recipient.email}>{recipient.email}</p>
            {recipient.phone && (
              <p className="text-xs text-gray-600 truncate" title={recipient.phone}>{recipient.phone}</p>
            )}
          </div>
        ) : (
          <p className="text-gray-500 italic text-sm">No recipient selected</p>
        )}

        <button
          onClick={onAddRecipient}
          className="mt-3 w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 px-3 rounded-lg transition-colors"
        >
          {recipient ? 'Change Recipient' : 'Add Recipient'}
        </button>
      </div>
    </div>
  );
};

export default InvoiceForm;